var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.routeData.type)?_c(_vm.routeData.type,{tag:"component",attrs:{"route-data":_vm.routeData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }